<template>
  <!--
          作者：tao
          时间：2020-12-11
          描述：产品码-产品码列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="产品码：" prop="product_code">
          <el-input v-model="formInline.product_code" placeholder="请填写产品码"></el-input>
        </el-form-item>

        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="product_id" label="产品id"></el-table-column>
          <el-table-column prop="product.product_name" label="产品名称"></el-table-column>
          <el-table-column prop="product_code" label="产品码"></el-table-column>
          <el-table-column prop="machine_code" label="设备编码"></el-table-column>
          <el-table-column prop="use_time" label="时长(分钟)"></el-table-column>
          <el-table-column prop="use_count" label="总次数"></el-table-column>
          <el-table-column prop="is_export" label="是否导出" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.is_export == 0" class="green">导出</span>
              <span v-if="scope.row.is_export == 1" class="green">已导出</span>
            </template>
          </el-table-column>
          <el-table-column prop="export_time" label="导出时间" width="180"></el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="180"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <el-button size="small" type="info" @click="cancelFunc">返回</el-button>

  </div>
</template>

<script>
import ProductApi from '@/api/product.js';
export default {
  components: {

  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        product_code: '',
      },
    };
  },
  created() {
    /*获取列表*/
    this.batch = this.$route.query.batch;
    this.getTableList();

  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.batch = self.batch;
      ProductApi.ProductCodeDetail(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.detail.data;
          self.totalDataNumber = data.data.detail.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*取消*/
    cancelFunc() {
      this.$router.push('/product/productcode/index');

    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      self.getTableList();
    },


  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/product/productcode/detail.vue